// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAgbEbSh_LxhFvrOKxneNT6jC7pM_Zowhk",
  authDomain: "property-listing-ee5d2.firebaseapp.com",
  projectId: "property-listing-ee5d2",
  storageBucket: "property-listing-ee5d2.firebasestorage.app",
  messagingSenderId: "286806140901",
  appId: "1:286806140901:web:111f48796cac8e989eb10c",
  measurementId: "G-DHKS485TY3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

function normalizeStorageBucket(bucket) {
  return String(bucket || "").replace(/^gs:\/\//, "").trim();
}

const primaryStorageBucket = normalizeStorageBucket(
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || firebaseConfig.storageBucket,
);
const fallbackStorageBucket = normalizeStorageBucket(
  process.env.REACT_APP_FIREBASE_STORAGE_FALLBACK_BUCKET,
);

const auth = getAuth(app);
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
const storage = getStorage(app, `gs://${primaryStorageBucket}`);
const functions = getFunctions(app, "us-central1"); // IMPORTANT

export {
  app,
  auth,
  db,
  fallbackStorageBucket,
  functions,
  primaryStorageBucket,
  storage,
};
